import { RobotoLinkHoverUnderline } from "@/shared/components";
import { useTriggerById } from "@/shared/domain/actions/hooks";
import { useTriggerV2ById } from "@/shared/domain/triggers/hooks";
import { RobotoNotFoundException } from "@/shared/http";

interface TriggerLinkProps {
  triggerId: string;
}

/**
 * Resolves a trigger id to a name link. The unified read answers for anything
 * event-driven — including a legacy row already flipped to the v2 engine,
 * whose old evaluations still render here — so it runs first; only a
 * definitive not-found falls back to the legacy view (scheduled triggers).
 */
export function TriggerLink({ triggerId }: TriggerLinkProps) {
  const v2Result = useTriggerV2ById(triggerId);
  const v2NotFound =
    v2Result.isError && v2Result.error instanceof RobotoNotFoundException;
  const viewResult = useTriggerById(v2NotFound ? triggerId : undefined);

  const name = v2Result.data?.name ?? viewResult.data?.name;
  if (name === undefined) {
    return triggerId;
  }

  return (
    <RobotoLinkHoverUnderline to={`/triggers/${name}`}>
      {name}
    </RobotoLinkHoverUnderline>
  );
}
